module.exports = __webpack_public_path__ + "img/pay-success.76eb5c10.png";